import vueConfig from './index';
export default vueConfig;